<template>
  <div>
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="form-npa law-page">
        <div class="position">
          <div class="bg-white p-20">
            <div class="form-head">
              <Widget position="menu_profile"/>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    v-on="on"
                    class="navbar-toggler-profile"
                  >
                    {{ $t("Профиль") }} <span class="caret"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile"/>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <LawStatisticList
              v-if="list"
              :list="list.downloadLinks"
            />
          </div>
        </div>
      </div>

    </v-container>
  </div>
</template>
<script>

import {Trans} from "@/plugins/Translation"
import Widget from '@/components/app/Widget'
import LawStatisticList from '@/components/law/LawStatisticList.vue'
import { mapMutations } from "vuex"
import LAW from '@/model/law'

export default {
  name: 'LawStatistic',
  components: {
    Widget,
    LawStatisticList
  },

  data () {
    return {
      list: null
    }
  },

  mounted () {
    this.fetchData()
  },

  computed: {
    breadcrumbs () {
      return [
        {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
        {text: this.$i18n.t('Исполнение законов'), disabled: false, href:Trans.currentLocaleUrl + '/law'},
        {text: this.$i18n.t('Статистика'), disabled: true }
      ]
    }
  },

  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      LAW.getStatisticListAll().then((response) => {
        this.list = response
        this.setLoading(false)
      }).catch((error) => {

      })
    },

    getTypeTransName (type) {
      let findType = this.typeList.find(item => item.type == type);
      return findType ? findType.transName : ''
    },
  }
}
</script>
